
import {Receive_ruleForm,Receive_valueArr } from './mutation-type'

export default {
    
   getRuleForm({commit},ruleForm){
       console.log(ruleForm)
      commit(Receive_ruleForm,{ruleForm})
   },
   getARR({commit},voluearr){
      console.log(voluearr)
     commit(Receive_valueArr,{voluearr})
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js